import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f1973800&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f1973800', component.options)
    } else {
      api.reload('f1973800', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=f1973800&", function () {
      api.rerender('f1973800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Users/Index.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Users/Index.vue
// module id = IuXX
// module chunks = 0